import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { ImportTwilioNumbers } from 'pages/settings/pages/numbers/pages/ImportTwilioNumbers/ui/ImportTwilioNumbers'
import { ImportTwilioNumbersLayout } from 'pages/settings/pages/numbers/pages/ImportTwilioNumbers/layout/ImportTwilioNumbersLayout'
import { ImportTwilioNumbersEmpty } from 'pages/settings/pages/numbers/pages/ImportTwilioNumbers/ui/ImportTwilioNumbersEmpty/ImportTwilioNumbersEmpty'
import { ImportTwilioNumbersRoutes } from 'pages/settings/pages/numbers/pages/ImportTwilioNumbers/route/type'

export const ImportTwilioNumbersRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<ImportTwilioNumbersLayout />}>
        <Route path={'/'} element={<ImportTwilioNumbers />} />
        <Route path={`${ImportTwilioNumbersRoutes.empty}`} element={<ImportTwilioNumbersEmpty />} />
      </Route>
    </RoutesWithNotFound>
  )
}
